import React from "react";
import Price from "../price";
import "./Footer.css";
import { FooterButton } from "./FooterButton";
import { useSelector } from 'react-redux';
import { IAppState } from '../../store';
import { MessageState } from '../../store/message/reducer';

export function Footer() {

  const messageState = useSelector<IAppState, MessageState>((state) => state.message);

  return (
    <div className="footer">
      <div className="footer-total">
        <Price />
        <FooterButton />
      </div>

      <div className="footer-info">
        {messageState && !messageState.display && 'All prices exclude VAT.'}
      </div>
    </div>
  );
}
